export default __webpack_public_path__ + "static/media/404.65479e2d.svg";